import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import eventBus from '../../eventBus';

export default function MobileBottomNav({ menuItems }) {
  const history = useHistory();
  const location = useLocation();
  const [value, setValue] = useState(
    menuItems.findIndex((item) =>
      item.paths
        ? item.paths.some((path) => location.pathname.startsWith(path))
        : location.pathname.startsWith(item.to),
    ),
  );

  const isPWA =
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true ||
    document.referrer.startsWith('android-app://');

  useEffect(() => {
    setValue(
      menuItems.findIndex((item) =>
        item.paths
          ? item.paths.some((path) => location.pathname.startsWith(path))
          : location.pathname.startsWith(item.to),
      ),
    );
  }, [location.pathname]);

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1300,
        display: 'block',
        '@media (min-width: 800px)': {
          display: 'none',
        },
        paddingBottom: isPWA ? '28px' : '0px',
      }}
      elevation={3}
    >
      <BottomNavigation
        showLabels
        value={value}
        onChange={(_, newValue) => {
          setValue(newValue);
          const item = menuItems[newValue];
          eventBus.dispatch('bottomNavigationClick');
          if (item.onClick) {
            item.onClick();
          } else {
            history.push(item.to);
          }
        }}
      >
        {menuItems.map((item, index) => (
          <BottomNavigationAction
            key={item.id}
            label={item.shortLabel || item.label}
            icon={
              index === value && item.filledIcon ? item.filledIcon : item.icon
            }
          />
        ))}
      </BottomNavigation>
    </Paper>
  );
}
